import React from 'react';
import { Button } from './ui/button';
import { Loader2, Sparkles, Check, X, AlertCircle } from 'lucide-react';

const confidenceColor = (level) => {
  if (level === 'high') return 'text-green-400';
  if (level === 'medium') return 'text-yellow-400';
  return 'text-red-400';
};

const AIEstimationCard = ({ estimation, showEstDetail, setShowEstDetail, applyEstimation, fetchEstimation, estLoading, canEstimate }) => {
  const price = estimation?.price;
  const duration = estimation?.duration;
  const hasPriceData = price && price.suggestedPrice > 0 && !price.noData;
  const hasDurationData = duration && duration.suggestedDuration > 0;

  return (
    <>
      <div className="flex items-center justify-between">
        <span className="text-green-400 font-semibold text-xs">Fiyat & Süre</span>
        <Button type="button" size="sm" onClick={fetchEstimation} disabled={estLoading || !canEstimate}
          className="bg-purple-600 hover:bg-purple-700 text-white text-xs h-7 px-2" data-testid="ai-estimate-btn">
          {estLoading ? <Loader2 className="h-3 w-3 animate-spin mr-1" /> : <Sparkles className="h-3 w-3 mr-1" />}
          AI Öneri
        </Button>
      </div>

      {estimation && showEstDetail && (
        <div className="bg-purple-900/20 border border-purple-700/40 rounded-lg p-3 space-y-2" data-testid="ai-estimation-card">
          <div className="flex items-center justify-between">
            <span className="text-purple-400 font-semibold text-xs flex items-center gap-1">
              <Sparkles className="h-3 w-3" />AI Fiyat & Süre Önerisi
            </span>
            <button type="button" onClick={() => setShowEstDetail(false)} className="text-gray-500 hover:text-gray-300">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {/* FIYAT */}
            <div className="bg-gray-900/50 rounded p-2">
              <p className="text-gray-500 text-[10px]">Önerilen Fiyat</p>
              {hasPriceData ? (
                <>
                  <p className="text-white font-bold text-lg">{price.suggestedPrice?.toLocaleString('tr-TR')} TL</p>
                  <p className="text-gray-500 text-[10px]">{price.minPrice?.toLocaleString('tr-TR')} - {price.maxPrice?.toLocaleString('tr-TR')} TL</p>
                  {price.isFallback && <p className="text-yellow-500 text-[10px] mt-0.5">Katalog fiyatına dayalı (düşük güven)</p>}
                  <Button type="button" size="sm" onClick={() => applyEstimation('price')}
                    className="mt-1.5 w-full bg-green-700 hover:bg-green-800 text-white text-[10px] h-6" data-testid="apply-price-btn">
                    <Check className="h-2.5 w-2.5 mr-1" />Fiyatı Uygula
                  </Button>
                </>
              ) : (
                <div className="flex items-center gap-1.5 mt-1">
                  <AlertCircle className="h-3.5 w-3.5 text-yellow-500" />
                  <span className="text-yellow-500 text-xs">Yeterli fiyat verisi bulunamadı</span>
                </div>
              )}
            </div>

            {/* SÜRE */}
            <div className="bg-gray-900/50 rounded p-2">
              <p className="text-gray-500 text-[10px]">Önerilen Süre</p>
              {hasDurationData ? (
                <>
                  <p className="text-white font-bold text-lg">{duration.suggestedDuration} saat</p>
                  <p className="text-gray-500 text-[10px]">{duration.minDuration} - {duration.maxDuration} saat</p>
                  <Button type="button" size="sm" onClick={() => applyEstimation('duration')}
                    className="mt-1.5 w-full bg-green-700 hover:bg-green-800 text-white text-[10px] h-6" data-testid="apply-duration-btn">
                    <Check className="h-2.5 w-2.5 mr-1" />Süreyi Uygula
                  </Button>
                </>
              ) : (
                <div className="flex items-center gap-1.5 mt-1">
                  <AlertCircle className="h-3.5 w-3.5 text-yellow-500" />
                  <span className="text-yellow-500 text-xs">Süre verisi bulunamadı</span>
                </div>
              )}
            </div>
          </div>

          {/* CONFIDENCE & GENEL UYGULA */}
          <div className="flex items-center justify-between">
            <span className={`text-xs ${confidenceColor(estimation.confidence?.level)}`}>
              Güven: {Math.round((estimation.confidence?.score || 0) * 100)}% ({estimation.confidence?.level === 'high' ? 'yüksek' : estimation.confidence?.level === 'medium' ? 'orta' : 'düşük'})
            </span>
            {(hasPriceData || hasDurationData) && (
              <Button type="button" size="sm" onClick={() => applyEstimation('all')}
                className="bg-purple-600 hover:bg-purple-700 text-white text-[10px] h-6" data-testid="apply-all-btn">
                Tümü Uygula
              </Button>
            )}
          </div>

          <p className="text-gray-500 text-[10px]">{estimation.explanation}</p>
          {estimation.similarJobsCount > 0 && (
            <p className="text-gray-600 text-[10px]">{estimation.similarJobsCount} benzer iş analiz edildi</p>
          )}
        </div>
      )}
    </>
  );
};

export default AIEstimationCard;
